import { z } from "zod";

export const CreateCategorySchema = z.object({
  name: z.string().min(1, "Category name is required").trim(),
  description: z.string().trim().optional(),
  jobTypeIds: z.array(z.string().uuid()).min(1, "At least one job type is required"),
  active: z.boolean().default(true),
});

export const UpdateCategorySchema = z.object({
  name: z.string().min(1).trim().optional(),
  description: z.string().trim().optional(),
  jobTypeIds: z.array(z.string().uuid()).optional(),
  active: z.boolean().optional(),
});

export const AddSubtaskSchema = z.object({
  name: z.string().min(1, "Subtask name is required").trim(),
  active: z.boolean().default(true),
});

export const UpdateSubtaskSchema = z.object({
  name: z.string().min(1).trim().optional(),
  active: z.boolean().optional(),
});

export const CreateJobTypeSchema = z.object({
  code: z
    .string()
    .min(1, "Code is required")
    .regex(/^[A-Z0-9]+$/, "Code must be uppercase letters and numbers only"),
  label: z.string().min(1, "Label is required").trim(),
  active: z.boolean().default(true),
});

export const UpdateJobTypeSchema = z.object({
  label: z.string().min(1).trim().optional(),
  active: z.boolean().optional(),
  sortOrder: z.number().int().nonnegative().optional(),
});

export type CreateCategoryInput = z.infer<typeof CreateCategorySchema>;
export type UpdateCategoryInput = z.infer<typeof UpdateCategorySchema>;
export type AddSubtaskInput = z.infer<typeof AddSubtaskSchema>;
export type UpdateSubtaskInput = z.infer<typeof UpdateSubtaskSchema>;
export type CreateJobTypeInput = z.infer<typeof CreateJobTypeSchema>;
export type UpdateJobTypeInput = z.infer<typeof UpdateJobTypeSchema>;
